<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date"><span class="">下单时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker 
							v-model="orderForm.beginTime"
							type="month"
							placeholder="选择日期"
							name="start-date"
							class="setTimePicker"
							value-format="yyyyMM"
							>
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						
						<el-date-picker 
							v-model="orderForm.endTime"
							type="month"
							placeholder="选择日期"
							name="start-date"
							class="setTimePicker"
							value-format="yyyyMM"
							>
						</el-date-picker>
					</span>
				</div>
				<!-- <div class="order-query-form-box">
					<label for="start-date">视图类型：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.waybillState" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in waybillStateList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div> -->
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList()">查询</span>
			</div>
		</div>
		<div class="platform-content-box ">
			<div class="platform-content-left ">
				<div class="data-table-box">
					<div class="data-table">
						<el-table :data="dataList"   @selection-change="handleSelectionChange"  class="st-table-center"  >
							<el-table-column prop="dateMonthFormatted" label="日期" width="180">
							</el-table-column>
							<el-table-column prop="weight" label="总重量" width="180">
							</el-table-column>
							<el-table-column prop="ownerExpressFee" label="收取货主的总运费" show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="volume" label="总方数"  >
							</el-table-column>
						</el-table>
					</div>
					<div class="st-order-bottom">
						<div class="page-floote-box clearfix fl" v-show="togglePage">
							<div class="st-page-switch">
								<span class="st-page-prev":class="this.listPage.current<=1?'stDisabled':''"   @click="pagePrev"></span>
								<span class="st-page-current"><input type="text" v-model="listPage.current"></span>
								<span class="st-page-next" :class="listPage.current>=listPage.pages?'stDisabled':''" @click="pageNext"></span>
							</div>
							<el-select v-model="listPage.currentSize" placeholder="请选择" class="st-page-pagers" >
								<el-option
								v-for="item in listPage.sizes"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="st-page-total">/共{{listPage.total}}条</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data-table-warp-right ">
				<div id="myChart" ref="myChart" ></div>
			</div>
		</div>
	</div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'PlatformPerformance',
    props: [],
    data() {
		return {
			dataList:[],
			orderForm:{
				beginTime: '', // 下单起始时间  
				endTime: '', // 下单结束时间 
			},
			Xdate:[],
			Ydata:[],
			waybillStateList:[{
					value: 1,
					label: '类型一'
				}, {
					value: 1,
					label: '类型二'
				}, {
					value: 1,
					label: '类型三'
			}],
			listPage:{
				currentSize:50,
				current: 1, //分页起始位置
				total: 0, // 总数量
				sizes: [{value:50,label:'每页50条'},{value:100,label:'每页100条'},{value:200,label:'每页200条'},{value:300,label:'每页300条'}], //分页大小
				page:1,
				pages:0,//总页数
			},
			togglePage:false, //是否显示分页

		}
    },
	components: {},
	created() {

	},
	methods: {
		searchList(){
			let pages={};
			pages.size=this.listPage.currentSize;
			pages.current=1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		// 上一页
		pagePrev(){
			let pages={};
			pages.size=this.listPage.currentSize;
			if(this.listPage.current<=1){
				return ;
			}
			let orderForm=this.orderForm;
			pages.current=--this.listPage.current;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		// 下一页
		pageNext(){
			let pages={};
			pages.size=this.listPage.currentSize;
			if(this.listPage.current>=this.listPage.pages){
				return ;
			}
			let orderForm=this.orderForm;
			pages.current=++this.listPage.current;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		getData(data){
			let Xdate=[];
			let Ydata=[];
			this.$server.report.waybillStatisticsPage(data,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.listPage.total=res.data.total;
					this.listPage.current=res.data.current;
					this.listPage.pages=res.data.pages;
					if(res.data.total>0){
						this.togglePage=true;
					}
					res.data.records.forEach(item=>{
						Xdate.push(item.dateMonthFormatted)
						Ydata.push(item.volume)
					})
					this.Xdate=Xdate;
					this.Ydata=Ydata;
					this.drawLine();
				}
			})
		},
		drawLine(){
       	 	// 基于准备好的dom，初始化echarts实例
			let myChart = this.$echarts.init(document.getElementById('myChart'));
			var date=this.Xdate.reverse();
			var data=this.Ydata.reverse();
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					position: function (pt) {
						return [pt[0], '10%'];
					}
				},
				title: {
					left: 'center',
					text: '平台业界情况',
				},
				toolbox: {
					feature: {
						dataZoom: {
							yAxisIndex: 'none'
						},
						restore: {},
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: date
				},
				yAxis: {
					type: 'value',
					boundaryGap: [0, '100%']
				},
				dataZoom: [{
					type: 'inside',
					start: 0,
					end: 100
				}, {
					start: 0,
					end: 10,
					handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
					handleSize: '80%',
					handleStyle: {
						color: '#fff',
						shadowBlur: 3,
						shadowColor: 'rgba(0, 0, 0, 0.6)',
						shadowOffsetX: 2,
						shadowOffsetY: 2
					}
				}],
				series: [
					{
						name: '模拟数据',
						type: 'line',
						smooth: true,
						symbol: 'none',
						sampling: 'average',
						itemStyle: {
							color: 'rgb(255, 70, 131)'
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgb(255, 158, 68)'
							}, {
								offset: 1,
								color: 'rgb(255, 70, 131)'
							}])
						},
						data: data
					}
				]
			})
		},
	
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
		}
	},
	mounted() {
		this.searchList();
		
	}
}

</script>
<style scoped >

.query-setting-box {
	display: flex;
	height: auto;
	background: #FFF;
	padding: 18px 8px 0;
	position: relative;
	overflow: hidden;
	font-size: 14px;
	margin-bottom: 8px;
}
.query-setting-box-left{
	flex-grow: 0;
}
.order-query-form-box {
  float: left;
  width: 140px;
  height: auto;
  margin: 0 24px 18px 0;
}
.order-query-form-box-right{
	padding-top: 22px;
	width: 80px;
}

.order-query-form-box label {
  display: block;
  width: 100%;
  height: 22px;
  line-height: 22px;
  color: #383838;
}
.createTimeItem{
	background-color: #FF5B3E;
	color: #fff;
	padding-right: 4px;
}
.createTimeItem i{
	display: inline-block;
	width: 8px;
	height: 12px;
	background: url('../../assets/images/icon_select.png') center no-repeat;
	background-size: 100% 100%;
	margin-left: 12px;
	vertical-align: middle;
}

.order-query-form-box input {
  display: block;
  width: 99%;
  height: 28px;
  line-height: 28px;
  border: 1px solid #DCDCDC;
  border-radius: 3px;
}

.order-query-form-submit {
  display: block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #FFF;
  background: #FF5B3E;
  border: 1px solid #FF5B3E;
  border-radius: 3px;
  margin: 0 auto;
}
.platform-content-box{ 
	display: flex;
	justify-content: space-between;
	flex-grow: 1;
}

.platform-content-left{
	width: 844px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.data-table {
	margin-bottom: 8px;
	box-sizing: border-box;
}

.data-table-warp-right{
	width: 951px;
	box-sizing: border-box;
	padding: 8px;
	background-color: #Fff;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
#myChart{
	width: 100%;
	height: 600px;
}
@media only screen and (max-width: 1366px) {
	.platform-content-left {
		width: 586px;
	}
	.data-table-warp-right {
		width: 660px;
	}
}
</style>
